// const mtnServiceID = `${process.env.REACT_APP_MTN_SERVICE_ID}`;
const mtnghCode = `${process.env.REACT_APP_MTNGH_CODE}`;
const tcelghCode = `${process.env.REACT_APP_TCELGH_CODE}`;


const getServiceProvider = async (number) => {

	const mtnCode = [
		"23324", "23325", "23353", "23354", "23355", "23359"
	];
	const telecelCode = ["23320", "23350"];
	// const tigoAirtelCode = ["23327.", "23357", "23326.", "23356"];
	let serviceProvider = "";

	if (mtnCode.includes(number.substring(0, 5))) {
		serviceProvider = mtnghCode;
	}
	if (telecelCode.includes(number.substring(0, 5))) {
		serviceProvider = tcelghCode;
	}
	// if (tigoAirtelCode.includes(number.substring(0, 5))) {
	// 	serviceProvider = vodafoneServiceID;
	// }

	return serviceProvider;
};

export default getServiceProvider;
